<template>
    <div>
        <div id="header-container" class="px-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Apply Bank Account') }}</h3>
                <span class="fz-16 fw-400">Create an account tailored to your needs.</span>
            </div>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0 pb-5">
                            <h3 class="pl-3 pt-3 pb-2">{{ $t('Select Account Type') }}</h3>

                            <div class="p-2 mb-4">
                                <div class="row mt-4">
                                    <div class="col-lg-6 col-md-12 pb-5">
                                        
                                        <div class="block-item account-type p-3">
                                            <div class="px-3 mb-3 d-flex flex-column align-items-center text-center">
                                                <div class="fz-20 fw-700">{{ $t('China Enterprise') }}</div>
                                                <div class="fz-14 fw-400 bank-account">
                                                    <span>{{ $t('Enterprise') }}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column mb-3">
                                                <div class="d-flex flex-column mb-3">
                                                    <div class="fz-18 fw-600">{{ $t('Withdrawal Requirements:') }}</div>
                                                    <div>{{ $t('Can be withdrawn to your own savings card.') }}</div>
                                                </div>
                                                <div class="d-flex flex-column mb-3">
                                                    <div class="fz-18 fw-600">{{ $t('Information requirements:') }}</div>
                                                    <div>{{ $t('Photos of the front and back of personal ID card, photo of holding ID card.') }}</div>
                                                </div>
                                            </div>
                                            <button class="d-block btn btn-primary w-100 py-2" @click="applyNow('china')">{{ $t('Apply Now') }}</button>
                                        </div>

                                    </div>

                                    <div class="col-lg-6 col-md-12 pb-5">
                                        
                                        <div class="block-item account-type p-3">
                                            <div class="px-3 mb-3 d-flex flex-column align-items-center text-center">
                                                <div class="fz-20 fw-700">{{ $t('Hong Kong Enterprise') }}</div>
                                                <div class="fz-14 fw-400 bank-account">
                                                    <span>{{ $t('Enterprise') }}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column mb-3">
                                                <div class="d-flex flex-column mb-3">
                                                    <div class="fz-18 fw-600">{{ $t('Withdrawal Requirements:') }}</div>
                                                    <div>{{ $t('Can be withdrawn to your own savings card.') }}</div>
                                                </div>
                                                <div class="d-flex flex-column mb-3">
                                                    <div class="fz-18 fw-600">{{ $t('Information requirements:') }}</div>
                                                    <div>{{ $t('Hong Kong identity card or passport photo, holding ID photo.') }}</div>
                                                </div>
                                            </div>
                                            <button class="d-block btn btn-primary w-100 py-2" @click="applyNow('hongkong')">{{ $t('Apply Now') }}</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
  
    export default {
        name: 'account-opening',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                stepList:["Select Bank Account","Account Type", "Information"]
            }
        },
        components: {
            LoaderComponent,
            stepContainer
        },
        methods:{
            applyNow(type){
                if(type == 'hongkong'){
                    this.$router.push({ 
                        path: 'hongkong-basic-information',
                    });
                }
                else{
                    this.$router.push({ 
                        path: 'china-basic-information',
                    });
                }
            }
        },
        mounted(){
            
        }
    };
  </script>

<style>
.point .number{
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}
</style>